import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** door with arrow, sign out. Decorative line icon; always pair with a visible text label. */
export function LogoutIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M14.5 4H6.5A1.5 1.5 0 0 0 5 5.5v13A1.5 1.5 0 0 0 6.5 20h8" />
      <path d="M15.5 8l4 4-4 4" />
      <path d="M19.5 12H9.5" />
    </IconSvg>
  )
}
